/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SectionPermission,
    SectionPermissionFromJSON,
    SectionPermissionFromJSONTyped,
    SectionPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalPermissions
 */
export interface GlobalPermissions {
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    adminPortal?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    userPermissions?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    searchManager?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    searchManagerDiagnostics?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    markupDiagnostics?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    globalFilterDiagnostics?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    bookingCreateManagerOsis?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    bookingCreateManagerRemarks?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    regions?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    countries?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    cities?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    airports?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    airlines?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    agencies?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    agencyGroups?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    providerCredentials?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    providerPreferences?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    identityProviderSettings?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    identitySettings?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    markups?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    ticketTLO?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    shoppingDiagnostics?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    technicalLogs?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    brands?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    markets?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    distributionChannels?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    globalFilters?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    activityLog?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    supplierLocationMappings?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    providers?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    ancillarySuppliers?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    ancillaryDistributions?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    vccCredentials?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    ssrRules?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    bookingTolerances?: SectionPermission;
    /**
     * 
     * @type {SectionPermission}
     * @memberof GlobalPermissions
     */
    ancillaryManager?: SectionPermission;
}

export function GlobalPermissionsFromJSON(json: any): GlobalPermissions {
    return GlobalPermissionsFromJSONTyped(json, false);
}

export function GlobalPermissionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalPermissions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'adminPortal': !exists(json, 'adminPortal') ? undefined : SectionPermissionFromJSON(json['adminPortal']),
        'userPermissions': !exists(json, 'userPermissions') ? undefined : SectionPermissionFromJSON(json['userPermissions']),
        'searchManager': !exists(json, 'searchManager') ? undefined : SectionPermissionFromJSON(json['searchManager']),
        'searchManagerDiagnostics': !exists(json, 'searchManagerDiagnostics') ? undefined : SectionPermissionFromJSON(json['searchManagerDiagnostics']),
        'markupDiagnostics': !exists(json, 'markupDiagnostics') ? undefined : SectionPermissionFromJSON(json['markupDiagnostics']),
        'globalFilterDiagnostics': !exists(json, 'globalFilterDiagnostics') ? undefined : SectionPermissionFromJSON(json['globalFilterDiagnostics']),
        'bookingCreateManagerOsis': !exists(json, 'bookingCreateManagerOsis') ? undefined : SectionPermissionFromJSON(json['bookingCreateManagerOsis']),
        'bookingCreateManagerRemarks': !exists(json, 'bookingCreateManagerRemarks') ? undefined : SectionPermissionFromJSON(json['bookingCreateManagerRemarks']),
        'regions': !exists(json, 'regions') ? undefined : SectionPermissionFromJSON(json['regions']),
        'countries': !exists(json, 'countries') ? undefined : SectionPermissionFromJSON(json['countries']),
        'cities': !exists(json, 'cities') ? undefined : SectionPermissionFromJSON(json['cities']),
        'airports': !exists(json, 'airports') ? undefined : SectionPermissionFromJSON(json['airports']),
        'airlines': !exists(json, 'airlines') ? undefined : SectionPermissionFromJSON(json['airlines']),
        'agencies': !exists(json, 'agencies') ? undefined : SectionPermissionFromJSON(json['agencies']),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : SectionPermissionFromJSON(json['agencyGroups']),
        'providerCredentials': !exists(json, 'providerCredentials') ? undefined : SectionPermissionFromJSON(json['providerCredentials']),
        'providerPreferences': !exists(json, 'providerPreferences') ? undefined : SectionPermissionFromJSON(json['providerPreferences']),
        'identityProviderSettings': !exists(json, 'identityProviderSettings') ? undefined : SectionPermissionFromJSON(json['identityProviderSettings']),
        'identitySettings': !exists(json, 'identitySettings') ? undefined : SectionPermissionFromJSON(json['identitySettings']),
        'markups': !exists(json, 'markups') ? undefined : SectionPermissionFromJSON(json['markups']),
        'ticketTLO': !exists(json, 'ticketTLO') ? undefined : SectionPermissionFromJSON(json['ticketTLO']),
        'shoppingDiagnostics': !exists(json, 'shoppingDiagnostics') ? undefined : SectionPermissionFromJSON(json['shoppingDiagnostics']),
        'technicalLogs': !exists(json, 'technicalLogs') ? undefined : SectionPermissionFromJSON(json['technicalLogs']),
        'brands': !exists(json, 'brands') ? undefined : SectionPermissionFromJSON(json['brands']),
        'markets': !exists(json, 'markets') ? undefined : SectionPermissionFromJSON(json['markets']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : SectionPermissionFromJSON(json['distributionChannels']),
        'globalFilters': !exists(json, 'globalFilters') ? undefined : SectionPermissionFromJSON(json['globalFilters']),
        'activityLog': !exists(json, 'activityLog') ? undefined : SectionPermissionFromJSON(json['activityLog']),
        'supplierLocationMappings': !exists(json, 'supplierLocationMappings') ? undefined : SectionPermissionFromJSON(json['supplierLocationMappings']),
        'providers': !exists(json, 'providers') ? undefined : SectionPermissionFromJSON(json['providers']),
        'ancillarySuppliers': !exists(json, 'ancillarySuppliers') ? undefined : SectionPermissionFromJSON(json['ancillarySuppliers']),
        'ancillaryDistributions': !exists(json, 'ancillaryDistributions') ? undefined : SectionPermissionFromJSON(json['ancillaryDistributions']),
        'vccCredentials': !exists(json, 'vccCredentials') ? undefined : SectionPermissionFromJSON(json['vccCredentials']),
        'ssrRules': !exists(json, 'ssrRules') ? undefined : SectionPermissionFromJSON(json['ssrRules']),
        'bookingTolerances': !exists(json, 'bookingTolerances') ? undefined : SectionPermissionFromJSON(json['bookingTolerances']),
        'ancillaryManager': !exists(json, 'ancillaryManager') ? undefined : SectionPermissionFromJSON(json['ancillaryManager']),
    };
}

export function GlobalPermissionsToJSON(value?: GlobalPermissions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'adminPortal': SectionPermissionToJSON(value.adminPortal),
        'userPermissions': SectionPermissionToJSON(value.userPermissions),
        'searchManager': SectionPermissionToJSON(value.searchManager),
        'searchManagerDiagnostics': SectionPermissionToJSON(value.searchManagerDiagnostics),
        'markupDiagnostics': SectionPermissionToJSON(value.markupDiagnostics),
        'globalFilterDiagnostics': SectionPermissionToJSON(value.globalFilterDiagnostics),
        'bookingCreateManagerOsis': SectionPermissionToJSON(value.bookingCreateManagerOsis),
        'bookingCreateManagerRemarks': SectionPermissionToJSON(value.bookingCreateManagerRemarks),
        'regions': SectionPermissionToJSON(value.regions),
        'countries': SectionPermissionToJSON(value.countries),
        'cities': SectionPermissionToJSON(value.cities),
        'airports': SectionPermissionToJSON(value.airports),
        'airlines': SectionPermissionToJSON(value.airlines),
        'agencies': SectionPermissionToJSON(value.agencies),
        'agencyGroups': SectionPermissionToJSON(value.agencyGroups),
        'providerCredentials': SectionPermissionToJSON(value.providerCredentials),
        'providerPreferences': SectionPermissionToJSON(value.providerPreferences),
        'identityProviderSettings': SectionPermissionToJSON(value.identityProviderSettings),
        'identitySettings': SectionPermissionToJSON(value.identitySettings),
        'markups': SectionPermissionToJSON(value.markups),
        'ticketTLO': SectionPermissionToJSON(value.ticketTLO),
        'shoppingDiagnostics': SectionPermissionToJSON(value.shoppingDiagnostics),
        'technicalLogs': SectionPermissionToJSON(value.technicalLogs),
        'brands': SectionPermissionToJSON(value.brands),
        'markets': SectionPermissionToJSON(value.markets),
        'distributionChannels': SectionPermissionToJSON(value.distributionChannels),
        'globalFilters': SectionPermissionToJSON(value.globalFilters),
        'activityLog': SectionPermissionToJSON(value.activityLog),
        'supplierLocationMappings': SectionPermissionToJSON(value.supplierLocationMappings),
        'providers': SectionPermissionToJSON(value.providers),
        'ancillarySuppliers': SectionPermissionToJSON(value.ancillarySuppliers),
        'ancillaryDistributions': SectionPermissionToJSON(value.ancillaryDistributions),
        'vccCredentials': SectionPermissionToJSON(value.vccCredentials),
        'ssrRules': SectionPermissionToJSON(value.ssrRules),
        'bookingTolerances': SectionPermissionToJSON(value.bookingTolerances),
        'ancillaryManager': SectionPermissionToJSON(value.ancillaryManager),
    };
}


